export default __webpack_public_path__ + "static/media/BLE_VOC.641a48e6.png";